import API from '../../../config/initAxios';
import { handleAlertModal } from '../../../shared/utilities/handleAlertModal';
import { modalType } from '../../../config/Enum/AlertModal';
import { processType } from '../../../config/Enum/ProcessingModal';
import { getApiResponse } from '../../../shared/utilities/getApiResponse';
import { getNextStepPage } from '../../../shared/utilities/getNextStepPage';
import { setCookie } from '../../../shared/utilities/setCookie';
import {
  CENTRAL_BANK_REDIRECT_URL,
  CENTRAL_BANK_REFERRAL_NAME,
  DIVAR_REDIRECT_URL,
  DIVAR_REFERRAL_NAME,
  EITTA_REDIRECT_URL,
  EITTA_REFERRAL_NAME,
  FATA_REDIRECT_URL,
  FATA_REFERRAL_NAME,
  NEXT_STEP_TOKEN,
  NEXT_STEP_URI,
  UID_REDIRECT_URL,
  UID_REFERRAL_NAME,
} from '../../../shared/constants/other';
import {nextStepPage, nextStepTokenResponse} from '../../../config/Enum/NextStep';
import getCookie from '../../../shared/utilities/getCookie';
import { SET_MULTIPLE } from '../../../redux/handleProcessingModal/ProcessingModal';
import {StepPages} from "../../../proto/out/ir/uid/base/base";
import BusinessRedirectUser from "../../../Components/BusinessRedirectUser";
import {RedirectReason} from "../../../proto/out/ir/uid/services/session_api";
import { navigateAway } from '../../../shared/utilities/backNavigationGuard';

export const dynamicApi = ({
  request,
  response,
  getValueFromRequest,
  dispatch,
  onProcessingModal,
  method,
  promiseResolve,
  onResponseContext,
  navigate,
  onError,
  onFinally,
  //TODO:
  redirectUrl,
  setRedirectUrl,
}: any) => {
  const getEncodeValue = request.encode(getValueFromRequest).finish();
  const bufferEncodeValue = new Int8Array(getEncodeValue);

  //TODO: change this code to dynamic later
  const businessId = getCookie('business_id');
  const isEitta = businessId === process.env.REACT_APP_EITTA_BUSINESS_ID;
  const isFata = businessId === process.env.REACT_APP_FATA_BUSINESS_ID;
  const handleProcessingModal = (processingModal: boolean, processType: string) => {
    dispatch({
      type: SET_MULTIPLE,
      payload: {
        processingModal: processingModal,
        processType: processType,
      },
    });
  };
  API.post(method, bufferEncodeValue)
    .then(handleResponse)
    .catch(() => {
      handleAlertModal({
        dispatch,
        modalType: modalType.ALERT,
        modalDescription: 'عدم برقراری ارتباط با سرور',
        //TODO: change this code to dynamic later
        // modalButtonUrl: isEitta ? EITTA_REDIRECT_URL : isFata ? FATA_REDIRECT_URL : DIVAR_REDIRECT_URL,
        // modalButtonUrl: isFata ? FATA_REFERRAL_NAME : getCookie('referralName'),
        modalButtonUrl: getCookie('referralName'),
      });
    })
    .finally(() => {
      onProcessingModal && onProcessingModal(false, processType.WAITING);
      onFinally && onFinally();
    });
  async function handleResponse(res: any) {
    const result = res.data;
    const a = await result.arrayBuffer();
    const encodeResult = new Uint8Array(a);
    const getValueResponse = response.decode(encodeResult);
    onResponseContext(getValueResponse);

    if (getValueResponse?.responseContext.nextStep[nextStepTokenResponse.GENERAL].navigationURI) {
      setCookie({
        cookieName: NEXT_STEP_URI,
        cookieValue: getValueResponse?.responseContext.nextStep[nextStepTokenResponse.GENERAL].navigationURI,
      });
      setCookie({
        cookieName: 'numberOfDigit',
        cookieValue: getValueResponse.responseContext.custom['number-of-digit'] === undefined?4:getValueResponse.responseContext.custom['number-of-digit'],
      });
    }

    setCookie({
      cookieName: NEXT_STEP_TOKEN,
      cookieValue: getValueResponse?.responseContext.nextStep[nextStepTokenResponse.GENERAL].nextStepToken,
    });

    if (getValueResponse?.redirectUrl) {
      // if (redirectUrl) {
      //   console.log('redirectUrl', redirectUrl)
      //   alert('redirectUrl')
      //   setRedirectUrl(getValueResponse?.redirectUrl);
      // } else if (getCookie('business_id') === process.env.REACT_APP_CENTRAL_BANK_BUSINESS_ID){
      //   console.log('CENTRAL_BANK', getValueResponse?.redirectUrl)
      //   // TODO this is toof condition
      //   handleProcessingModal(false, processType.WAITING);
      //   setRedirectUrl(getValueResponse?.redirectUrl);

      if (getValueResponse.responseContext?.nextStep[nextStepTokenResponse.GENERAL].nextStepPage === 0) {
        // for return to url without pages
        navigateAway(getValueResponse?.redirectUrl);
      }else {
        // for return to url with landing and button pages
        handleProcessingModal(false, processType.WAITING);
        setRedirectUrl(getValueResponse?.redirectUrl);
      }
    }

    if (promiseResolve) {
      promiseResolve(getValueResponse);
    }

    if (!getValueResponse?.redirectUrl) {
      getApiResponse({
        responseValue: getValueResponse,
        dispatch,
        onError,
        okResponse: () => {
          if (!promiseResolve) {
            getNextStepPage({ responseContext: getValueResponse, navigate });
          }
        },
      });
    }
  }
};
